import { Link as ScrollLink, Element } from "react-scroll"
import { IconsCheck, IconsChevronLeft, IconsClose } from "./Icons"
import { Input } from "./Input"
import { useEffect, useState } from "react"
import { TextArea } from "./TextArea"
import { Button } from "./Button"
import { NOTIFICATIONHTTP } from "../../api"
import { CircleLoader } from "./Loader"

const validationInit = {
    name: true,
    phone: true,
    city: true,
}

export const ModalOrder = ({
    open,
    close,
}: {
    open: boolean
    close: () => void
}) => {

    const [loading,setLoading] = useState<boolean>(false)
    const [city, setCity] = useState("Пловдив")
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [comment, setComment] = useState("")
    const [showAlert, setShowAlert] = useState(false)

    const [validation, setValidation] = useState(validationInit)

    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden"
        } else {
            document.body.style.overflow = ""
        }

        return () => {
            document.body.style.overflow = ""
        }
    }, [open])

    const sendMessage = async () => {
        try {
            if (!name) {
                setValidation((s) => ({ ...s, name: false }))
                return
            }
            if (!phone) {
                setValidation((s) => ({ ...s, phone: false }))
                return
            }
            if (!city) {
                setValidation((s) => ({ ...s, city: false }))
                return
            }

            await NOTIFICATIONHTTP.sendMessage({
                city,
                name,
                phone,
                comment,
            })
            setShowAlert(true)

            //@ts-ignore
            window?.gtag("event", "conversion", {
                send_to: "AW-16762469808/r_nuCPPPtOYZELD7-7g-",
                city,
                name,
                phone,
                comment,
            })
            //@ts-ignore
            window?.fbq("track", "Lead", {
                city,
                name,
                phone,
                comment,
            })
        } catch (error) {
            alert("Warning: error with order, ")
        }
    }
    const handlerPushNotification = async () => {
        try {
            setLoading(true)
             await sendMessage()
        setTimeout(() => {
            setShowAlert(false)
            close()
        }, 2000)
        } catch (error) {
              setLoading(false)
            alert("Warning: error with order, Admin - 0896608802")
        }
        finally{
            setLoading(false)
        }
       

    }



    useEffect(() => {
        setCity("Пловдив")
        setName("")
        setPhone("")
        setComment("")
    }, [open])

    if(loading) return <CircleLoader />
    return (
        <>
            {open && (
                <>
                    <div className="modal-order">
                        <button
                            className="modal-head-close modal-order-close"
                            onClick={close}
                        >
                            <IconsClose />
                        </button>
                        {showAlert ? (
                            <div className="modal-order-alert flex-all-center">
                                <h5>
                                    Всичко е наред, <br />
                                    заявката ви е оставена!
                                </h5>
                                <div className="modal-order-alert-icon">
                                    <IconsCheck />
                                </div>
                                <h5>всичко ще заблести Скоро!</h5>
                            </div>
                        ) : (
                            <>
                                <h5 className="modal-order-title">
                                    Оставете заявка
                                </h5>

                                <Input
                                    placeholder="Посочете вашия град"
                                    value={city}
                                    setValue={(s) => {
                                        setCity(s)
                                        setValidation(validationInit)
                                    }}
                                    validation={validation.city}
                                />
                                <Input
                                    placeholder="Вашето име"
                                    value={name}
                                    setValue={(s) => {
                                        setName(s)
                                        setValidation(validationInit)
                                    }}
                                    validation={validation.name}
                                />
                                <Input
                                    placeholder="Телефонен номер"
                                    value={phone}
                                    setValue={(s) => {
                                        setPhone(s)
                                        setValidation(validationInit)
                                    }}
                                    validation={validation.phone}
                                />
                                <TextArea
                                    placeholder="Коментар"
                                    value={comment}
                                    setValue={setComment}
                                />

                                <p className="modal-order-text">
                                    С натискането на бутона "Поръчка за
                                    почистване" вие се съгласявате с обработката
                                    на лични данни.
                                </p>
                                <div className="comments-list-all modal-order-button">
                                    <Button
                                        disabled={loading}
                                        icon={<IconsChevronLeft />}
                                        text="Поръчай почистване"
                                        onClick={handlerPushNotification}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <div className="modal-background" />
                </>
            )}
        </>
    )
}
